<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateCategory"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.categories')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.sub_category')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-12">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ categoriesForm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.code') }}:</strong>
                        </h6>
                        {{ categoriesForm.code }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.description') }}:</strong>
                        </h6>
                        {{ categoriesForm.description }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong
                            >{{ $t('common_words.sub_category') }}:</strong
                          >
                        </h6>
                        <div
                          class="mb-2"
                          v-for="(category, index) in categoriesForm.name_sub"
                          :key="index"
                        >
                          <el-tag
                            style="height: auto; color: black; width: 100%"
                            :type="
                              categoriesForm.enable[index] ? `info` : `danger`
                            "
                          >
                            <div class="row pt-2">
                              <div class="col-12 col-sm-6 col-md-4 col-xl-1">
                                <h6 class="mb-2">
                                  <strong>{{ $t('common_words.code') }}</strong>
                                </h6>
                                <p>
                                  {{ categoriesForm.code_sub[index] }}
                                </p>
                              </div>
                              <div class="col-12 col-sm-6 col-md-4 col-xl-3">
                                <h6 class="mb-2">
                                  <strong>{{ $t('common_words.name') }}</strong>
                                </h6>
                                <p
                                  class="col-text-ellipsis"
                                  v-tooltip.bottom="category"
                                >
                                  {{ category }}
                                </p>
                              </div>
                              <div class="col-12 col-sm-6 col-md-4 col-xl-2">
                                <h6
                                  class="mb-2 col-text-ellipsis"
                                  :v-tooltip.bottom="
                                    $t('common_words.description')
                                  "
                                >
                                  <strong>{{
                                    $t('common_words.description')
                                  }}</strong>
                                </h6>
                                <p>
                                  {{ categoriesForm.description_sub[index] }}
                                </p>
                              </div>
                            </div>
                          </el-tag>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { showContinue, resetObjectProperties } from 'src/util/Util.js';
import FirstStep from './steps/FirstStep.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './steps/SecondStep.vue';

export default {
  components: {
    FirstStep,
    SecondStep,
  },
  data() {
    return {
      title: '',
      categoriesForm: {
        name: null,
        code: null,
        description: null,
        code_sub: [],
        name_sub: [],
        description_sub: [],
        enable: [true],
      },
      renderComponent: true,
    };
  },

  mixins: [MixinAlert, MixinLoading, MixinMenu, MixinPermissions],

  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = {
        ...this.$refs.firstStep.initialModel,
      };
      this.$refs.secondStep.model = {
        ...resetObjectProperties({ ...this.$refs.secondStep.model }),
        enable: [true],
        subcategory_number: 1,
      };
      this.$refs.secondStep.enable = [];
      this.$refs.secondStep.subcategoriesCode = [];
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(model) {
      this.categoriesForm = { ...this.categoriesForm, ...model };
    },

    storeUpdateCategory() {
      this.showHideLoading(true);
      this.categoriesForm.route = 'assistance/categories';

      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.categoriesForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;
          Axios.updateMaster(this.categoriesForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/assistance/categories',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.categoriesForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/assistance/categories',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('assistance');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    sessionStorage.removeItem('tableCode');
    this.deselectedItemOnMenu('assistance');
  },
};
</script>
